const normalizeBase = (value) => {
  if (!value) return '';
  return String(value).trim().replace(/\/+$/, '');
};

const BACKEND_SHARE_BASE = 'https://api.joegalaxy.net';

const resolveBase = () => {
  const envBase =
    process.env.REACT_APP_SHARE_BASE_URL ||
    process.env.REACT_APP_AZURE_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL_PROD ||
    '';
  if (envBase) {
    return normalizeBase(envBase.replace(/\/api\/v1$/i, ''));
  }
  return normalizeBase(BACKEND_SHARE_BASE);
};

const getShareUrl = (type, id) => {
  const safeType = String(type || '').trim();
  const safeId = String(id || '').trim();
  if (!safeType || !safeId) return '';
  const base = resolveBase();
  const path = `/share/${encodeURIComponent(safeType)}/${encodeURIComponent(
    safeId,
  )}`;
  return base ? `${base}${path}` : path;
};

export default getShareUrl;
